import { PencilIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { IconButton } from "../../../../../components/ui";
import { buildContactNavigationTargetUrl } from "../../../components/searchResultNavigation";

const getContactIdFromValues = values => {
  return (
    values?.item?.contact?.id ||
    values?.item?.id ||
    values?.contact?.id ||
    values?.id
  );
};

const Actions = props => {
  const { values } = props || {};
  const id = getContactIdFromValues(values);

  if (typeof id == "number") {
    const query = new URLSearchParams(window.location.search);
    const href = buildContactNavigationTargetUrl({
      listContext: { locationSearch: window.location.search },
      recordId: id,
      status: query.get("status") || "all",
    });

    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid">
            <Link to={href} title="Edit User">
              <IconButton variant="clean" title="Edit User">
                <PencilIcon
                  className={`h-4 w-4 cursor-pointer text-gray-400`}
                />
              </IconButton>
            </Link>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
export { getContactIdFromValues };
